
define('text!common/views/commercial/creatives/manual-inline-button.html',[],function () { return '<a href="<%=clickMacro%><%=offer_url%>" class="button button--primary button--small" data-link-name="click here">\n    Click here<%=arrowRight%>\n</a>\n';});

